module.exports = __webpack_public_path__ + "img/p-leaving-room.9d7fac3a.jpg";